import EnrollForm from './enrol-form';

export default EnrollForm;
